<template>
  <div class="content" v-if="ready === 'ready'">
    <div class="page page-bg" ref="page">
      <div class="top-zw"></div>
      <div class="top">
        <img class="top-bg" src="../../assets/images/q_title_bg.png" alt="" />
        <div class="top-title">
          <span class="ttmg">第{{ anwNoIndex }}题</span
          ><span class="ttmg">共{{ anwTotalIndex }}题</span>
        </div>
      </div>

      <div class="problem">
        <span v-if="qdata.list[anwIndex].type === 1">【单选题】</span>
        <span v-if="qdata.list[anwIndex].type === 2">【判断题】</span>
        <span v-if="qdata.list[anwIndex].type === 3">【多选题】</span
        >{{ qdata.list[anwIndex].title }}
      </div>

      <div class="answer">
        <div class="answer-zw"></div>

        <div v-if="qdata.list[anwIndex].type === 1 && anwDisabled === false">
          <div
            v-for="(item, index) in qdata.list[anwIndex].answer"
            :key="index"
            @click="
              changeAnswerA(
                qdata.list[anwIndex].correct_answer,
                index,
                qdata.list[anwIndex].answer
              )
            "
            :class="{
              'answer-item': true,
              'answer-bg-yes': singleSelected === index
            }"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">{{ item }}</div>
            <div class="answer-item-zw"></div>
          </div>
          <img
            class="dx-btn"
            v-if="singleSelected !== null"
            src="../../assets/images/submit_btn.png"
            @click="submitSingle"
            alt=""
          />
        </div>
        <div
          v-else-if="qdata.list[anwIndex].type === 1 && anwDisabled === true"
        >
          <div
            v-for="(item, index) in qdata.list[anwIndex].answer"
            :key="index"
            :class="{
              'answer-item': true,
              'answer-bg-yes': answerReady === true && anwYesIndex === index,
              'answer-bg-no':
                answerReady === true &&
                anwYesIndex !== index &&
                changeIndex === index,
            }"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">{{ item }}</div>
            <div class="answer-item-zw"></div>
          </div>
        </div>

        <!-- 多选 -->
        <div v-if="qdata.list[anwIndex].type === 3 && anwDisabled === false">
          <div
            v-for="(item, index) in qdata.list[anwIndex].answer"
            :key="index"
            @click="
              changeAnswerC(
                qdata.list[anwIndex].correct_answer,
                index,
                qdata.list[anwIndex].correct_answer_arr
              )
            "
            :class="{
              'answer-item': true,
              'answer-bg-yes': dxresult.indexOf(index) !== -1 ? true : false,
            }"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">{{ item }}</div>
            <div class="answer-item-zw"></div>
          </div>
          <img
            class="dx-btn"
            v-if="dxresult.length > 0"
            src="../../assets/images/submit_btn.png"
            @click="submitDx"
            alt=""
          />
        </div>
        <div
          v-else-if="qdata.list[anwIndex].type === 3 && anwDisabled === true"
        >
          <div
            v-for="(item, index) in qdata.list[anwIndex].answer"
            :key="index"
            :class="{
              'answer-item': true,
              'answer-bg-yes':
                answerReady === true && dxAnwArray.indexOf(index) !== -1
                  ? true
                  : false,
              'answer-bg-no':
                answerReady === true &&
                dxAnwArray.indexOf(index) === -1 &&
                dxresult.indexOf(index) !== -1,
            }"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">{{ item }}</div>
            <div class="answer-item-zw"></div>
          </div>
        </div>

        <div v-if="qdata.list[anwIndex].type === 2 && anwDisabled === false">
          <div
            :class="{
              'answer-item': true,
              'answer-bg-yes':
                answerReady === true &&
                anwYesIndex === changeIndex &&
                changeIndex === 1
                  ? true
                  : false,
              'answer-bg-no':
                answerReady === true &&
                anwYesIndex !== changeIndex &&
                changeIndex === 1
                  ? true
                  : false,
            }"
            @click="changeAnswerB(qdata.list[anwIndex].correct_answer, 1)"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">A. 正确</div>
            <div class="answer-item-zw"></div>
          </div>
          <div
            :class="{
              'answer-item': true,
              'answer-bg-yes':
                answerReady === true &&
                anwYesIndex === changeIndex &&
                changeIndex === 0
                  ? true
                  : false,
              'answer-bg-no':
                answerReady === true &&
                anwYesIndex !== changeIndex &&
                changeIndex === 0
                  ? true
                  : false,
            }"
            @click="changeAnswerB(qdata.list[anwIndex].correct_answer, 0)"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">B. 错误</div>
            <div class="answer-item-zw"></div>
          </div>
        </div>

        <div
          v-else-if="qdata.list[anwIndex].type === 2 && anwDisabled === true"
        >
          <div
            :class="{
              'answer-item': true,
              'answer-bg-yes':
                answerReady === true &&
                anwYesIndex === changeIndex &&
                changeIndex === 1
                  ? true
                  : false,
              'answer-bg-no':
                answerReady === true &&
                anwYesIndex !== changeIndex &&
                changeIndex === 1
                  ? true
                  : false,
            }"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">A. 正确</div>
            <div class="answer-item-zw"></div>
          </div>
          <div
            :class="{
              'answer-item': true,
              'answer-bg-yes':
                answerReady === true &&
                anwYesIndex === changeIndex &&
                changeIndex === 0
                  ? true
                  : false,
              'answer-bg-no':
                answerReady === true &&
                anwYesIndex !== changeIndex &&
                changeIndex === 0
                  ? true
                  : false,
            }"
          >
            <div class="answer-item-zw"></div>
            <div class="ai">B. 错误</div>
            <div class="answer-item-zw"></div>
          </div>
        </div>
      </div>

      <div v-if="qqtype === '1'">
        <div
          class="tips-error"
          v-if="answerReady === true && anwYesIndex !== changeIndex"
        >
          回答错误
          <div v-if="qdata.list[anwIndex].type === 1">
            正确答案：{{ anwYes }}
          </div>
          <div
            v-if="
              qdata.list[anwIndex].type === 2 &&
              qdata.list[anwIndex].answer.length > 0 &&
              parseInt(qdata.list[anwIndex].correct_answer) === 0
            "
          >
            {{ qdata.list[anwIndex].answer[0] }}
          </div>
        </div>

        <div
          class="tips"
          v-else-if="answerReady === true && anwYesIndex === changeIndex"
        >
          回答正确
          <div
            v-if="
              qdata.list[anwIndex].type === 2 &&
              qdata.list[anwIndex].answer.length > 0 &&
              parseInt(qdata.list[anwIndex].correct_answer) === 0
            "
          >
            {{ qdata.list[anwIndex].answer[0] }}
          </div>
        </div>
      </div>

      <div v-if="qqtype === '2'">
        <div class="tips-error" v-if="answerReady === true && dxJg === 'no'">
          回答错误
          <div>正确答案：{{ anwYes }}</div>
        </div>

        <div class="tips" v-else-if="answerReady === true && dxJg === 'yes'">
          回答正确
        </div>
      </div>

      <div class="btn">
        <img
          class="btn-img"
          v-if="
            answerReady === true &&
            anwNoIndex !== qdata.list.length &&
            nextBtnDisabled === false
          "
          @click="goNext"
          src="../../assets/images/q_next_btn.png"
          alt=""
        />
        <img
          class="btn-img"
          v-else-if="
            answerReady === true &&
            anwNoIndex !== qdata.list.length &&
            nextBtnDisabled === true
          "
          src="../../assets/images/q_next_btn.png"
          alt=""
        />
        <img
          class="btn-img"
          v-if="answerReady === true && anwNoIndex === qdata.list.length"
          @click="submit"
          src="../../assets/images/q_btn.png"
          alt=""
        />
      </div>

      <div class="bottom-zw"></div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import api from "../../api";
import { showLoadingToast } from "vant";
const router = useRouter();
const page = ref(null);
const ready = ref("");
const qqtype = ref("");
/**
 * 获取题目
 */
const anwId = ref();
const qdata = reactive({ list: [] });
const anwIndex = ref(0); // 第几题
const anwNoIndex = ref(1);
const anwTotalIndex = ref(); // 第几题
const getData = async () => {
  try {
    const result = await api.getData({});
    if (result) {
      ready.value = "ready";
      anwId.value = result.id;
      qdata.list = result.list;
      anwTotalIndex.value = result.list.length;
    }
  } catch (error) {
    // closeToast()
    console.log(error);
  }
};
getData();
const nextBtnDisabled = ref(false);
const goNext = () => {
  nextBtnDisabled.value = true;
  answerReady.value = false; // 重置 是否点击过选项
  anwDisabled.value = false; // 重置 锁定选项
  singleSelected.value = null; // 重置 单选题选择
  // dx
  dxresult.value = [];
  dxAnwArray.value = [];
  dxAnw.value = [];
  dxJg.value = "";
  qqtype.value = "";
  // dx end
  anwIndex.value += 1;
  anwNoIndex.value += 1;
  page.value.scrollTo(0, 0);
  nextBtnDisabled.value = false;
};
/**
 * 题目选择
 */
// 答案
const answer = ref([]);
const answerReady = ref(false); // 是否点击过选项
const changeIndex = ref(); // 点击的序号
const anwYes = ref(""); // 正确答案的值
const anwYesIndex = ref(); // 正确答案的序号
const anwDisabled = ref(false); // 是否锁定选项
const singleSelected = ref(null); // 单选题当前选择的序号
const changeAnswerA = (anw, index, anwArray) => {
  // 点击的答案序号 index; 正确答案 anw; 答案数组 arrayAnw.
  if (anwDisabled.value) return; // 锁定后不响应
  singleSelected.value = index;
  // 记录正确答案
  anwYesIndex.value = anw;
  anwYes.value = anwArray[anw];
  changeIndex.value = index;
};

// 单选题提交
const submitSingle = () => {
  if (singleSelected.value === null) return;
  qqtype.value = "1";
  answerReady.value = true;
  // 将答案push到结果数组中
  if (singleSelected.value === 0) {
    answer.value.push("A");
  } else if (singleSelected.value === 1) {
    answer.value.push("B");
  } else if (singleSelected.value === 2) {
    answer.value.push("C");
  } else if (singleSelected.value === 3) {
    answer.value.push("D");
  } else if (singleSelected.value === 4) {
    answer.value.push("E");
  } else if (singleSelected.value === 5) {
    answer.value.push("F");
  }
  // 锁定选项
  anwDisabled.value = true;
};

// 多选题
const dxresult = ref([]);
const dxAnwArray = ref([]);
const dxAnw = ref([]);
const dxJg = ref("");
const changeAnswerC = (anw, index, anwArray) => {
  // 点击的答案序号 index; 正确答案 anw; 答案数组 arrayAnw.
  dxAnwArray.value = anwArray;
  dxAnw.value = anw;
  if (dxresult.value.indexOf(index) === -1) {
    dxresult.value.push(index);
  } else {
    dxresult.value = dxresult.value.filter((item) => item !== index);
  }
  console.log(dxresult.value);
};
const submitDx = () => {
  qqtype.value = "2";
  answerReady.value = true; // 点击过后将状态设置成true

  const replacedArray = dxresult.value.map((item) => {
    switch (item) {
      case 0:
        return "A";
      case 1:
        return "B";
      case 2:
        return "C";
      case 3:
        return "D";
      case 4:
        return "E";
      case 5:
        return "F";
      default:
        return item;
    }
  });
  // 将答案push到结果数组中
  answer.value.push(replacedArray.join("、"));
  // 正确答案的序号
  anwYesIndex.value = dxAnwArray.value;
  // 正确答案的内容
  anwYes.value = dxAnw.value;
  // 是否选择正确
  console.log("正确答案的序号", dxAnwArray.value);
  console.log("本体结果：", dxAnw.value.split("、"));
  console.log("本体选择的结果：", replacedArray);
  const isSubset = () => {
    if (dxAnw.value.split("、").length !== replacedArray.length) {
      return false;
    }
    return replacedArray.every((item) =>
      dxAnw.value.split("、").includes(item)
    );
  };
  if (isSubset()) {
    dxJg.value = "yes";
  } else {
    dxJg.value = "no";
  }
  // 锁定选项
  anwDisabled.value = true;
};

// 判断题
const changeAnswerB = (anw, index) => {
  qqtype.value = "1";
  answerReady.value = true; // 点击过后将状态设置成true
  // 将答案push到结果数组中
  if (index === 0) {
    answer.value.push("0");
  } else if (index === 1) {
    answer.value.push("1");
  }
  anwYesIndex.value = parseInt(anw);
  // 判断点击的是第几个
  changeIndex.value = index;
  // 锁定选项
  anwDisabled.value = true;
};
/**
 * 提交答案
 */
const submitDisable = ref(false);
const submit = () => {
  submitDisable.value = true;
  postData();
};
const postData = async () => {
  try {
    const result = await api.postData({
      answer: answer.value.toString(),
      id: anwId.value
    });
    if (result) {
      showLoadingToast({
        message: "提交中..",
        forbidClick: true
      });
      submitDisable.value = false;
      localStorage.resultQa20240822 = JSON.stringify(result);
      router.push({ name: "Result" });
    }
  } catch (error) {
    submitDisable.value = false;
    console.log(error + "error");
  }
};
</script>
<style></style>
<style lang="scss" scoped>
@import "../../../style/mixins.scss"; // 多行相同属性使用mixin混入代替
.dx-btn {
  width: 152px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin: 0;
  padding: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
}
.content {
  width: 100vw;
  height: 100vh;
  transform: translate3d(0, 0, 0);
  .swiper {
    width: 100vw;
    height: 100vh;
    .swiper-slide {
      transform: translate3d(0, 0, 0);
    }
  }
}
.page {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  position: relative;
  background-color: #f3f8e3;
}
.page-bg {
  width: 100vw;
  background-image: url("../../assets/images/q_bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
}
.top-zw {
  width: 100%;
  height: 48px;
}
.top {
  width: 161px;
  height: 43px;
  line-height: 43px;
  margin-left: 0;
  margin-right: auto;
  position: relative;
}
.top-bg {
  width: 161px;
  height: 43px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.top-title {
  width: 161px;
  height: 43px;
  line-height: 43px;
  text-align: left;
  font-size: 15px;
  font-weight: 400;
  color: #0068a1;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8;
}
.ttmg {
  margin-left: 14px;
}
.problem {
  width: 308px;
  font-size: 18px;
  font-weight: 500;
  color: #0068a1;
  line-height: 31px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  text-align: left;
}
.answer {
  width: 308px;
  margin-left: auto;
  margin-right: auto;
  color: #0068a1;
}
.answer-zw {
  width: 100%;
  height: 1px;
}
.answer-item {
  width: 308px;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 15px;
}
.answer-item-zw {
  width: 100%;
  height: 18px;
}
.answer-bg-yes {
  background: #16a603;
  color: #fff;
}
.answer-bg-no {
  background: #c42b2b;
  color: #fff;
}
.ai {
  width: 268px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.tips {
  width: 308px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 26px;
  font-size: 18px;
  font-weight: 600;
  color: #0068a1;
  text-align: center;
}
.tips-error {
  width: 308px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 26px;
  font-size: 18px;
  font-weight: 600;
  color: #e60012;
  text-align: center;
}
.btn {
  width: 152px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-top: 26px;
}
.btn-img {
  width: 152px;
  height: auto;
}
.bottom-zw {
  width: 100%;
  height: 40px;
}
</style>
